// コメント位置はPrettier対策
class AppCertification {
  //FIXME 本番設定に書き換えてください。
  /**
   * アプリケーションの定数値です。
   */
  APPVERSION = "26.04.01";
  APP_CONFIG = {
    //FIXME MockModeの有効無効
    // HttpClientのgetを対象として、dummy.jsonを読み込むフラグです。
    MOCK_MODE: false,

    /**
     * API接続用設定（VDI外アクセス）
     */
    // ryde環境(RY03）
    BASE_URL: "https://cirrus-wh-de.nkr.nikkon-is.com/",
  };

  /**
   * Cognitoの設定です。
   */
  //FIXME 本番設定に書き換えてください。
  //営業所用
  COGNITO = {
    USER_POOL_ID: "ap-northeast-1_jqf05fa3A",
    APP_CLIENT_ID: "1mmqonqqgjb3g5n56nfpkd2hfl",
  };

  //荷主用
  SHIPPER_COGNITO = {
    USER_POOL_ID: "ap-northeast-1_zWwFUKo16",
    APP_CLIENT_ID: "63umucrbrgc0k1ioa3j1dpcrv1",
  };

  /** datadog */
  DATADOG = {
    DD_APPLICATION_ID: "5153b534-a0c9-4d26-8270-1a8bb6dc0ebb",
    DD_CLIENT_TOKEN: "pub2c87c651f5b8ac1d9feda5417ad0aa66",
    DD_SERVICE: "wh-ryde-pc",
    DD_ENV: "wh-ryde",
    DD_SESSION: 20,
  };
  /** datadog */
}

export const appCertification = new AppCertification();
